// extracted by mini-css-extract-plugin
export var card = "card-split-module--card--f05ca";
export var cardContent = "card-split-module--cardContent--04e45";
export var date = "card-split-module--date--45b9d";
export var image = "card-split-module--image--721a0";
export var imagesContainer = "card-split-module--imagesContainer--39e01";
export var svg = "card-split-module--svg--efb2e";
export var svgContainer = "card-split-module--svgContainer--eaf73";
export var title = "card-split-module--title--5bb59";